<template lang="pug">
  .recover-password
    .card-login
      div(v-if="submitStatus === 'OK'")
        center
          img(src="../../../public/logo-main-clasworld.png" style="width: 205px")
          p.succes Email enviado correctamente, revisa tu correo y sigue las instrucciones para recuperar tu contraseña
          router-link.link(:to="{ name: 'login' }") Volver
      b-form(v-else @submit="onSubmit" novalidate)
        center
          img(src="../../../public/logo-main-clasworld.png" style="width: 205px")
          p 
            h5.text-center Recuperar contraseña
          .subtitle Se le enviará un email con las intrucciones para recuperar su contreseña
          <span>
              b-icon(icon="envelope")
          </span>
          b-form-input.input(
            placeholder="Correo"
            v-model="form.email"
            id="email-input"
            type="email"
            required
          )
          b-form-invalid-feedback(:state="submitStatus!=='ERROR'") Error al enviar email, verifique si su email es correcto
          b-form-invalid-feedback(:state="$v.form.email.email") Este campo debe se un email válido
        b-form-invalid-feedback(:state="$v.form.email.required") Este campo es requerido
        center
          b-button.boton(type="submit" variant="secondary" ) Enviar
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      form: {
        email: ''
      },
      submitStatus: 'PENDING'
    }
  },
  validations: {
    form: {
      email: {
        required,
        email
      }
    }
  },
  methods: {
    ...mapActions('AuthenticationStore', ['sendRecoverPasswordEmail']),
    async onSubmit (event) {
      event.preventDefault()
      if (this.$v.$invalid) {
        this.submitStatus = 'PENDING'
      } else {
        const { email } = this.form 
        const response = await this.sendRecoverPasswordEmail({ email })
        if (!response) {
          this.submitStatus = 'ERROR'
        } else {
          this.submitStatus = 'OK'
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .card-login{
    background: white;
  }
  span{
    position: absolute;
    margin-left: 15px;
    height: 50px;
    display: flex;
    align-items: center;
  }
  input{
    padding-left: 35px;
    height: 50px;
  }
  .subtitle{
    color:#7F828F;
    text-align:center;
    font-size: 14px;;
    margin-bottom: 30px;
  }

  .succes{
    margin-top: 100px;
  }
  .boton{
    margin: 70px;
    color: white;
  }
  .link {
    color: var(--secondary);
  }

</style>